import { ValidateAuthTotpPayload, validateAuthTotpApi } from '@/api/v1/users/authValidateTotpApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';

export const validateAuthTotp = async (payload: ValidateAuthTotpPayload) => {
  try {
    const response = await validateAuthTotpApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
